module.exports = __webpack_public_path__ + "static/badracket.com-v4.f4a98ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/badracket.com-v4.jpg
// module id = ./src/pages/badracket.com-v4.jpg
// module chunks = 19913542803863